const banner = [
  {
    path: "/banner/manage",
    name: "bannerManage",
    component: () => import("@/view/banner/manage"),
  },
];
export default banner;
